// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-default[data-v-6d00b852]{color:#333}`, "",{"version":3,"sources":["webpack://./ClientApp/components/kanban/modal/detailscontent/Tasks.vue"],"names":[],"mappings":"AACA,8BACE,UAAA","sourcesContent":["\r\n.btn-default {\r\n  color: #333;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
